import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {USER_TABS} from 'src/constants';
import {Layouts} from 'src/modules/profile/user/tabs/content/layouts/layouts';
import {UserWorkspaces} from 'src/modules/profile/user/tabs/content/workspace/user-workspaces';

import {UserSearchAlerts} from './alerts/user-search-alerts';
import {Lists} from './lists/lists';
import {Searches} from './searches/searches';

type Props = {
    userId: number,
};

export const ContentRouter = ({userId}: Props) => {
    return (
        <>
            <Routes>
                <Route
                    path="searches"
                    element={<Searches userId={userId}/>}
                />
                <Route
                    path="lists"
                    element={<Lists userId={userId}/>}
                />
                <Route
                    path="alerts"
                    element={<UserSearchAlerts userId={userId}/>}
                />
                <Route
                    path="workspaces"
                    element={<UserWorkspaces userId={userId}/>}
                />
                <Route
                    path="layouts"
                    element={<Layouts userId={userId}/>}
                />
                <Route
                    path="*"
                    element={(
                        <Navigate to={`/profile/user/${userId}/${USER_TABS.CONTENT.name}/searches`}/>
                    )}
                />
            </Routes>
        </>
    );
};
